//created by sudip
import { motion } from "framer-motion";
import {
    Smartphone,
    Users,
} from "lucide-react";

interface FloatingMobileCardProps{
    accent:string;
}

export function FloatingMobileCard({

    accent,

}:FloatingMobileCardProps){

    return(

        <motion.div

            animate={{
                y:[0,10,0],
            }}

            transition={{
                duration:6,
                repeat:Infinity,
                ease:"easeInOut",
            }}

            className="
                absolute
                -right-20
                -top-20
                z-30
                w-60
                rounded-3xl
                border
                border-white/60
                bg-white/90
                p-5
                shadow-2xl
                backdrop-blur-xl
            "
        >

            <div className="flex items-center gap-3">

                <div
                    className="
                        flex
                        h-11
                        w-11
                        items-center
                        justify-center
                        rounded-xl
                    "
                    style={{
                        backgroundColor:`${accent}15`,
                    }}
                >

                    <Smartphone
                        className="h-5 w-5"
                        style={{
                            color:accent,
                        }}
                    />

                </div>

                <div>

                    <h4 className="text-sm font-bold text-slate-900">

                        Mobile Workforce

                    </h4>

                    <p className="text-xs text-slate-500">

                        Connected Field Teams

                    </p>

                </div>

            </div>

            <div className="mt-6 flex items-center justify-between">

                <div>

                    <p className="text-3xl font-bold text-slate-900">

                        1,248

                    </p>

                    <p className="text-xs text-slate-500">

                        Engineers Online

                    </p>

                </div>

                <Users
                    className="h-8 w-8"
                    style={{
                        color:accent,
                    }}
                />

            </div>

        </motion.div>

    );

}